import { explorerAddressUrl, explorerTxUrl, shortAddress } from "../lib/format";

export function ExplorerAddressLink({
  explorerUrl,
  address,
  label,
}: {
  explorerUrl: string;
  address: string;
  label?: string;
}) {
  return (
    <a
      href={explorerAddressUrl(explorerUrl, address)}
      target="_blank"
      rel="noreferrer noopener"
      className="mono"
    >
      {label ?? shortAddress(address)}
      <span className="visually-hidden"> (opens block explorer in a new tab)</span>
    </a>
  );
}

export function ExplorerTxLink({
  explorerUrl,
  txHash,
  label,
}: {
  explorerUrl: string;
  txHash: string;
  label?: string;
}) {
  return (
    <a
      href={explorerTxUrl(explorerUrl, txHash)}
      target="_blank"
      rel="noreferrer noopener"
      className="mono"
    >
      {label ?? shortAddress(txHash)}
      <span className="visually-hidden"> (opens block explorer in a new tab)</span>
    </a>
  );
}
